module.exports = __webpack_public_path__ + "img/jf-check.a5caeb46.jpg";